<template>
  <Fragment>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="拍码统计" name="first">
        <div class="card-wrap mt-20 mb-20">
          <section class="card-content">
            <div class="left">
              <div class="search-name mr-15">
                <span>开始时间：</span>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  v-model="startShootDate"
                  type="date"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </div>
              <div class="search-name mr-15">
                <span>结束时间：</span>
                <el-date-picker
                  format="yyyy-MM-dd"
                  v-model="endShootDate"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                  :default-time="endShootDate"
                >
                </el-date-picker>
              </div>
              <el-button
                type="primary"
                class="ml-20"
                @click="searchMarketingTimeInfo"
                >查询
              </el-button>
              <el-button
                type="primary"
                class="ml-20"
                @click="exportMarketingTime"
                >下载
              </el-button>
            </div>
          </section>
        </div>
        <div>
          <span> 拍码总数:{{ numberSum }} </span>
        </div>
        <br />
        <el-table :data="list" style="width: 150%" border>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍码时间" width="600">
            <template slot-scope="scope">
              <span>{{ scope.row.shootDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍码数">
            <template slot-scope="scope">
              <span>{{ scope.row.number }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-20 pagination"
          background
          layout="total,prev, pager, next, jumper"
          :total="total"
          :page-size="10"
          :current-page="pageNum"
          @prev-click="handlePrePage"
          @next-click="handleNextPage"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="多维度拍码统计" name="second">
        <div class="card-wrap mt-20 mb-20">
          <section class="card-content">
            <div class="left">
              <div class="search-name mr-15">
                <span>年：</span>
                <el-select v-model="year" clearable placeholder="请选择">
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.year"
                    :label="item.year"
                    :value="item.year"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>月：</span>
                <el-select
                  v-model="month"
                  clearable
                  placeholder="请选择"
                  @change="monthTest()"
                >
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.month"
                    :label="item.month"
                    :value="item.month"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>季度：</span>
                <el-select
                  v-model="quarter"
                  clearable
                  placeholder="请选择"
                  @change="quarterTest()"
                >
                  <el-option
                    v-for="item in quarterOptions"
                    :key="item.quarter"
                    :label="item.quarter"
                    :value="item.quarter"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>省：</span>
                <el-input v-model="provinceName"></el-input>
              </div>
              <div class="search-name mr-15">
                <span>市：</span>
                <el-input v-model="cityName"></el-input>
              </div>
              <el-button
                type="primary"
                class="ml-20"
                @click="searchTimeAndAreaInfo"
                >查询
              </el-button>
              <el-button
                type="primary"
                class="ml-20"
                @click="exportMarketTimeAndAreaMedia"
                >下载
              </el-button>
            </div>
          </section>
        </div>
        <div>
          <span> 拍码总数:{{ numberSum }} </span>
        </div>
        <br />
        <el-table :data="timeAndAreaList" style="width: 150%" border>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{
                scope.$index +
                  (timeAndAreaPageNum - 1) * timeAndAreaPageSize +
                  1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍码时间" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.shootDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="省" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.provinceName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="市" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.cityName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍码数">
            <template slot-scope="scope">
              <span>{{ scope.row.number }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-20 pagination"
          background
          layout="total,prev, pager, next, jumper"
          :total="total"
          :page-size="10"
          :current-page="pageNum"
          @prev-click="timeAndAreaPrePage"
          @next-click="timeAndAreaNextPage"
          @current-change="timeAndAreaChange"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="时间维度" name="third">
        <div class="card-wrap mt-20 mb-20">
          <section class="card-content">
            <div class="left">
              <div class="search-name mr-15">
                <span>开始时间：</span>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  v-model="startShootDate"
                  type="date"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </div>
              <div class="search-name mr-15">
                <span>结束时间：</span>
                <el-date-picker
                  format="yyyy-MM-dd"
                  v-model="endShootDate"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                  :default-time="endShootDate"
                >
                </el-date-picker>
              </div>
              <el-button
                type="primary"
                class="ml-20"
                @click="searchMarketingTimeInfo"
                >查询
              </el-button>
            </div>
          </section>
        </div>
        <br />
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:25px;font-weight:bold;text-align: center;display:block;color: #409EFF"
            >{{ marketingName }} 拍码数： {{ numberSum }}</span
          >
        </div>
      </el-tab-pane>
      <el-tab-pane label="地区维度" name="fourth">
        <br />
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:20px;font-weight:bold;text-align: center;display:block;color: #409EFF"
            >{{ marketingName }} 拍码数：
            {{ numberSum }} 下图是拍码前十名的地区</span
          >
        </div>
      </el-tab-pane>
      <el-tab-pane label="多维度图表统计" name="five">
        <div class="card-wrap mt-20 mb-20">
          <section class="card-content">
            <div class="left">
              <div class="search-name mr-15">
                <span>年：</span>
                <el-select v-model="year" clearable placeholder="请选择">
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.year"
                    :label="item.year"
                    :value="item.year"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>月：</span>
                <el-select
                  v-model="month"
                  clearable
                  placeholder="请选择"
                  @change="monthTest()"
                >
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.month"
                    :label="item.month"
                    :value="item.month"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>季度：</span>
                <el-select
                  v-model="quarter"
                  clearable
                  placeholder="请选择"
                  @change="quarterTest()"
                >
                  <el-option
                    v-for="item in quarterOptions"
                    :key="item.quarter"
                    :label="item.quarter"
                    :value="item.quarter"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>省：</span>
                <el-input v-model="provinceName"></el-input>
              </div>
              <div class="search-name mr-15">
                <span>市：</span>
                <el-input v-model="cityName"></el-input>
              </div>
              <el-button
                type="primary"
                class="ml-20"
                @click="searchTimeAndAreaInfo"
                >查询
              </el-button>
            </div>
          </section>
        </div>
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:25px;font-weight:bold;text-align: center;display:block;color: #409EFF"
            >{{ marketingName }} 拍码数： {{ numberSum }}</span
          >
        </div>
      </el-tab-pane>
      <el-tab-pane label="多维度图表统计" name="six">
        <div class="card-wrap mt-20 mb-20">
          <section class="card-content">
            <div class="left">
              <div class="search-name mr-15">
                <span>年：</span>
                <el-select v-model="year" clearable placeholder="请选择">
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.year"
                    :label="item.year"
                    :value="item.year"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>月：</span>
                <el-select
                  v-model="month"
                  clearable
                  placeholder="请选择"
                  @change="monthTest()"
                >
                  <el-option
                    v-for="item in yearOptions"
                    :key="item.month"
                    :label="item.month"
                    :value="item.month"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>季度：</span>
                <el-select
                  v-model="quarter"
                  clearable
                  placeholder="请选择"
                  @change="quarterTest()"
                >
                  <el-option
                    v-for="item in quarterOptions"
                    :key="item.quarter"
                    :label="item.quarter"
                    :value="item.quarter"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="search-name mr-15">
                <span>省：</span>
                <el-input v-model="provinceName"></el-input>
              </div>
              <div class="search-name mr-15">
                <span>市：</span>
                <el-input v-model="cityName"></el-input>
              </div>
              <el-button
                type="primary"
                class="ml-20"
                @click="searchTimeAndAreaInfo"
                >查询
              </el-button>
            </div>
          </section>
        </div>
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:25px;font-weight:bold;text-align: center;display:block;color: #409EFF"
            >{{ marketingName }} 拍码数： {{ numberSum }}</span
          >
        </div>
      </el-tab-pane>
    </el-tabs>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Fragment
  },
  data() {
    return {
      marketingId: "",
      startShootDate: "",
      endShootDate: new Date(),
      marketingName: "",
      shootDate: "",
      numberSum: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      activeName: "first",
      year: "",
      month: "",
      quarter: "",
      cityName: "",
      provinceName: "",
      timeAndAreaList: [],
      timeAndAreaPageNum: 1,
      timeAndAreaPageSize: 10,
      timeAndAreaTotal: 0,
      quarterOptions: [
        {
          quarter: "1"
        },
        {
          quarter: "2"
        },
        {
          quarter: "3"
        },
        {
          quarter: "4"
        }
      ],
      yearOptions: [
        {
          year: "2013",
          month: "1"
        },
        {
          year: "2014",
          month: "2"
        },
        {
          year: "2015",
          month: "3"
        },
        {
          year: "2016",
          month: "4"
        },
        {
          year: "2017",
          month: "5"
        },
        {
          year: "2018",
          month: "6"
        },
        {
          year: "2019",
          month: "7"
        },
        {
          year: "2020",
          month: "8"
        },
        {
          year: "2021",
          month: "9"
        },
        {
          year: "2022",
          month: "10"
        },
        {
          year: "2023",
          month: "11"
        },
        {
          year: "2024",
          month: "12"
        }
      ]
    };
  },
  methods: {
    getMarketingTimeInfo(id) {
      let _this = this;
      let param = {
        url: "/api/marketing/getMarketingTimeByMarketingId",
        params: {
          marketingId: _this.marketingId,
          startShootDate: _this.startShootDate,
          endShootDate: _this.endShootDate,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getMarketingTimeList", param).then(() => {
        _this.list = _this.$store.state.marketingEnd.marketingTimeList.list;
        _this.total = _this.$store.state.marketingEnd.marketingTimeList.total;
        if (_this.list.length > 0) {
          _this.startShootDate = _this.list[0].shootDate;
        }
      });
    },
    //查询
    searchMarketingTimeInfo() {
      let _this = this;
      if (Date.parse(_this.startShootDate) > Date.parse(_this.endShootDate)) {
        _this.$message({
          message: "开始时间不能大于结束时间",
          type: "error"
        });
      }
      _this.getMarketingTimeInfo();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getMarketingTimeInfo();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getMarketingTimeInfo();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getMarketingTimeInfo();
    },
    //拍码统计下载
    exportMarketingTime() {
      let _this = this;
      let param = {
        marketingId: _this.marketingId,
        marketingName: _this.marketingName,
        startTimeStr: _this.startShootDate,
        endTimeStr: _this.endShootDate,
        numberSum: _this.numberSum
      };
      _this.$Api
        .post("/api/marketing/exportMarketingTime", param)
        .then(response => {
          if (response.status === 200) {
            _this.$Api.exportExcel(
              ["拍码总数", "拍码时间", "拍码数"],
              ["numberSum", "shootDate", "number"],
              response.data,
              _this.marketingName
            );
          } else {
            _this.$message({
              message: "无法获取导出数据",
              type: "warning"
            });
          }
        });
    },
    getTimeAndAreaInfo(id) {
      let _this = this;
      let param = {
        url: "/api/marketing/getMarketTimeAndAreaMediaByMarketingId",
        params: {
          marketingId: _this.marketingId,
          year: _this.year,
          month: _this.month,
          quarter: _this.quarter,
          cityName: _this.cityName,
          provinceName: _this.provinceName,
          timeAndAreaPageNum: _this.timeAndAreaPageNum,
          timeAndAreaPageSize: _this.timeAndAreaPageSize
        }
      };

      _this.$store.dispatch("getTimeAndAreaInfo", param).then(() => {
        _this.timeAndAreaList =
          _this.$store.state.marketingEnd.marketingTimeAndAreaList.list;
        _this.timeAndAreaTotal =
          _this.$store.state.marketingEnd.marketingTimeAndAreaList.total;
      });
    },
    //多维度拍码统计下载
    exportMarketTimeAndAreaMedia() {
      let _this = this;
      let param = {
        marketingId: _this.marketingId,
        year: _this.year,
        month: _this.month,
        quarter: _this.quarter,
        cityName: _this.cityName,
        provinceName: _this.provinceName,
        numberSum: _this.numberSum
      };
      _this.$Api
        .post("/api/marketing/exportMarketTimeAndAreaMediaByMarketingId", param)
        .then(response => {
          if (response.status === 200) {
            _this.$Api.exportExcel(
              ["拍码总数", "拍码时间", "省", "市", "拍码数"],
              ["numberSum", "shootDate", "provinceName", "cityName", "number"],
              response.data,
              _this.marketingName
            );
          } else {
            _this.$message({
              message: "无法获取导出数据",
              type: "warning"
            });
          }
        });
    },
    //多维度拍码统计查询
    searchTimeAndAreaInfo() {
      let _this = this;
      _this.getTimeAndAreaInfo();
    },
    //多维度拍码统计当前页
    timeAndAreaChange(value) {
      let _this = this;
      _this.categoryPageNum = value;
      _this.searchTimeAndAreaInfo();
    },
    //多维度拍码统计右侧上一页
    timeAndAreaPrePage() {
      let _this = this;
      _this.categoryPageNum -= 1;
      _this.searchTimeAndAreaInfo();
    },
    //多维度拍码统计右侧下一页
    timeAndAreaNextPage() {
      let _this = this;
      _this.categoryPageNum += 1;
      _this.searchTimeAndAreaInfo();
    },
    //月验证
    monthTest() {
      let _this = this;
      if (_this.year === "") {
        _this.$message({
          message: "请先选择年",
          type: "error"
        });
        _this.month = "";
      }
      if (_this.quarter !== "") {
        _this.$message({
          message: "已选择季度不能再选月份",
          type: "error"
        });
        _this.month = "";
      }
    },
    //季度验证
    quarterTest() {
      let _this = this;
      if (_this.year === "") {
        _this.$message({
          message: "请先选择年",
          type: "error"
        });
        _this.quarter = "";
      }
      if (_this.month !== "") {
        _this.$message({
          message: "已选择月份不能再选季度",
          type: "error"
        });
        _this.quarter = "";
      }
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.marketingId;
    _this.marketingId = this.$route.params.marketingId;
    _this.marketingName = this.$route.params.marketingName;
    _this.numberSum = this.$route.params.number;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getMarketingTimeInfo(id);
      _this.getTimeAndAreaInfo(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
    .card-content
        display: flex
        align-items: center
        justify-content: space-between

        .left
            display: flex

        .el-button
            font-size: 14px

        .search-name, .search-code
            font-size: 14px
            display: flex
            align-items: center

            span
                white-space: nowrap

    .pagination
        text-align: center
</style>
